export default {
    logo: require('../assets/images/logo.png'),
    personal: require('../assets/images/me.png'),
    avatar_1: require('../assets/images/avatar_1.jpg'),
    avatar_2: require('../assets/images/avatar_2.jpg'),
    avatar_3: require('../assets/images/avatar_3.jpg'),
    moc_1: require('../assets/images/moc_1.png'),
    moc_2: require('../assets/images/moc_2.png'),
    moc_3: require('../assets/images/moc_3.png'),
    moc_4: require('../assets/images/moc_4.jpg'),
}